import React from 'react';
import { Gamepad2, CalendarDays, Library, Headphones } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'BONO 1: Juegos Fonológicos',
    bullets: ['Refuerza la base sonora', 'Actividades simples', 'Enfoque progresivo'],
    icon: Gamepad2,
    color: 'bg-blue-100 text-blue-600',
    image: 'https://cdn.magicpatterns.com/uploads/8PsY4X35Rw8twZ9icGsP2R/bono_1.png'
  }, {
    title: 'BONO 2: Calendario Visual',
    bullets: ['Seguimiento claro', 'Refuerza autoestima', 'Estructura diaria'],
    icon: CalendarDays,
    color: 'bg-green-100 text-green-600',
    image: 'https://cdn.magicpatterns.com/uploads/jHfH1MMr482VHekovAvFAc/bono_2.png'
  }, {
    title: 'BONO 3: Mini Biblioteca Inicial',
    bullets: ['Textos simples decodificables', 'Aplicación sin frustración', 'Lectura progresiva'],
    icon: Library,
    color: 'bg-yellow-100 text-yellow-600',
    image: 'https://cdn.magicpatterns.com/uploads/m9x5F5vVZWfgmW8EMTB3qF/bono_3.png'
  }, {
    title: 'BONO 4: Audio Calmante Guiado',
    bullets: ['Acompañamiento emocional', 'Reduce tensión antes de leer', 'Genera seguridad'],
    icon: Headphones,
    color: 'bg-purple-100 text-purple-600',
    image: 'https://cdn.magicpatterns.com/uploads/vEWfUm4Gf1aggM5GeBrSjj/bono_4.png'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <div className="text-center mb-16" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-4" data-id="element-12">
            Y además hoy vienen incluidos estos
          </h2>
          <div className="inline-block bg-[#C2644C] text-white px-6 py-2 rounded-full text-xl font-bold shadow-lg transform -rotate-1" data-id="element-13">
            BONOS exclusivos totalmente gratis
          </div>
        </div>

        <div className="space-y-10" data-id="element-14">
          {bonuses.map((bonus, index) => <div key={index} className="flex flex-col md:flex-row items-center bg-[#F5F1EA] rounded-2xl p-6 md:p-8 shadow-sm border border-[#5C6B60]/10 gap-6 md:gap-8" data-id="element-15">
              {/* Image */}
              <div className="w-full md:w-[120px] flex-shrink-0" data-id="element-16">
                <div className="aspect-square rounded-xl overflow-hidden shadow-md" data-id="element-17">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-18" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left" data-id="element-19">
                <div className="flex items-center justify-center md:justify-start mb-3" data-id="element-20">
                  <div className={`p-2 rounded-lg ${bonus.color} mr-3`} data-id="element-21">
                    <bonus.icon className="w-5 h-5" data-id="element-22" />
                  </div>
                  <h3 className="text-xl font-bold text-[#2D3648]" data-id="element-23">
                    {bonus.title}
                  </h3>
                </div>

                <ul className="space-y-2 inline-block text-left" data-id="element-24">
                  {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-center text-[#4A5568]" data-id="element-25">
                      <span className="w-1.5 h-1.5 bg-[#5C6B60] rounded-full mr-2" data-id="element-26" />
                      {bullet}
                    </li>)}
                </ul>
              </div>

              <div className="md:self-center" data-id="element-27">
                <span className="text-[#C2644C] font-bold text-lg line-through opacity-60 block text-center md:text-right" data-id="element-28">
                  $15.000
                </span>
                <span className="text-[#5C6B60] font-bold text-xl block text-center md:text-right" data-id="element-29">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}